import script from "./SystemStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemStatus.vue?vue&type=script&setup=true&lang=js"

import "./SystemStatus.vue?vue&type=style&index=0&id=5723945e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5723945e"]])

export default __exports__